import React from 'react';
import cx from 'classnames';
import { COPY_STRINGS } from '../../../constants/translatedCopy';

export default class RANItems extends React.Component {

  //TODO: refactor so that this isn't a RAN component but an "Image" component?
  render() {
    let ranStyles = cx({
      'ranImage': true,
      'outlined': true,
      'example': this.props.isInstruction,
    });

    return (
      <div className="ranItems">
        {this.props.isInstruction && <div className="exampleIndicator">{COPY_STRINGS.example}:</div>}
        <img className={ranStyles} src={this.props.image} alt="" />
      </div>
    );
  }
}
